import { DatabaseRecord } from "../repos/table.repo";

interface WaterSupplySuspensionLevelModelExt {
    provinceName?: string;
    districtName?: string;
    wardName?: string;
    tollAreaName?: string;
}

export interface WaterSupplySuspensionLevelModel extends DatabaseRecord, WaterSupplySuspensionLevelModelExt {
    waterFactoryId: string;
    waterSupplySuspensionId: string;
    provinceId: string;
    districtId: string;
    wardId: string;
    tollAreaId?: string | null;
    startTime?: Date;
    endTime?: Date;
}

export class WaterSupplySuspensionLevelModelFactory {
    static getEmpty(waterSupplySuspensionId: string = ""): WaterSupplySuspensionLevelModel {
        return {
            id: "",
            waterFactoryId: "",
            waterSupplySuspensionId,
            provinceId: "",
            districtId: "",
            wardId: "",
            tollAreaId: null,
            startTime: new Date(),
            endTime: new Date()
        };
    }
}
